/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SellerSettings as AgentApiContractSellerSettings } from '../../models/AgentApi/Contract/seller-settings';

export interface ApiAgentGetSellerSettingsGet$Plain$Params {

/**
 * system language
 */
  lang?: string;
}

export function apiAgentGetSellerSettingsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentGetSellerSettingsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractSellerSettings>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetSellerSettingsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractSellerSettings>;
    })
  );
}

apiAgentGetSellerSettingsGet$Plain.PATH = '/api/Agent/GetSellerSettings';
